import * as Sentry from '@sentry/react';

export const captureSupabaseError = (
  err: unknown,
  context?: Record<string, unknown>
) => {
  Sentry.captureException(err, {
    tags: { source: 'supabase' },
    extra: context,
  });
};
